import { AsyncPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewChild, inject } from '@angular/core';
import { Router } from '@angular/router';
import { IconKey } from '../../../../../../whitelabel/icon-key.enum';
import { MenuModel } from '../../../../../osp-ui/components/menu/menu/contract/menu-model.contract';
import { MenuComponent } from '../../../../../osp-ui/components/menu/menu/menu.component';
import { AvatarComponent } from '../../../../../osp-ui/components/misc/avatar/avatar.component';
import { IconPipe } from '../../../../../shared/pipes/icon.pipe';
import { AuthService } from '../../../../services/auth.service';
import { LanguageService } from '../../../../services/language.service';

@Component({
  selector: 'osp-user-settings-menu',
  standalone: true,
  imports: [MenuComponent, AvatarComponent, AsyncPipe, IconPipe, NgClass],
  templateUrl: './user-settings-menu.component.html',
  styleUrl: './user-settings-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserSettingsMenuComponent {
  private router = inject(Router);
  private authService = inject(AuthService);
  private languageService = inject(LanguageService);

  @ViewChild('menu') menu!: MenuComponent;

  public userProfile$ = this.authService.userProfile$;

  protected readonly IconKey = IconKey;
  protected readonly options: MenuModel = [
    {
      label: this.translate('modules.userrole.userSettings.userSettings'),
      command: () => {
        this.router.navigate(['/user/settings']);
      },
    },
    {
      label: this.translate('modules.navigation.sidebar.logout'),
      command: () => {
        this.authService.logout();
      },
      styleClass: 'menu-item--danger',
    },
  ];

  toggleMenu(event: Event): void {
    this.menu.toggle(event);
  }

  private translate(key: string): string {
    return this.languageService.getInstant(key);
  }
}
